// extracted by mini-css-extract-plugin
module.exports = {"hBox":"HBox_hBox"};